import DomainSettingsForm from './DomainSettingsForm.vue'
export default DomainSettingsForm